import React from 'react';
import withStyles from '@material-ui/core/styles/withStyles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';

import '../../styles/Analytics.css';

import OnboardingGraph from './OnboardingGraph';
import OnboardingUsers from '../../containers/onboarding/OnboardingUsers';

const styles = theme => ({
  tableContainer: {
    maxWidth: 1000,
    '& table:first-child': {
      '& tr': {
        '& td:first-child, th:first-child': {
          backgroundColor: '#ffffff',
          position: 'sticky',
          left: 0,
          zIndex: 11,
        },
        '& th:first-child': {
          zIndex: 11,
        },
      },
    },
  },
  paper: {
    color: theme.palette.text.secondary,
    marginBottom: 24,
    display: 'flex',
    flexDirection: 'column',
    padding: 15,
  },
  entriesDataTitle: {
    fontSize: 18,
    textAlign: 'center',
    fontWeight: 'bold',
  },
  entriesStartedValue: {
    color: '#FF3B00',
    fontSize: 40,
    textAlign: 'center',
    fontWeight: 'bold',
  },
  filteredEntriesValue: {
    color: '#FF8900',
    fontSize: 40,
    textAlign: 'center',
    fontWeight: 'bold',
  },
  entriesCompletedValue: {
    color: '#00BC2B',
    fontSize: 40,
    textAlign: 'center',
    fontWeight: 'bold',
  },
  entriesDataSubValue: {
    color: '#000000',
    fontSize: 18,
    marginLeft: 15,
  },
});

class OnboardingAnalyticsHome extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      fieldInput: false,
      valueInput: false,
      value: '',
      momentSuggestions: [],
      momentSelected: {},
    };
  }

  onChange = (event, { newValue }) => {
    this.setState({
      value: newValue,
    });
  };

  renderSwitch(tab) {
    const { onboardingProgressAnalytics, tableData } = this.props;
    switch (tab) {
      case 0:
        return (
          <OnboardingGraph
            onboardingProgressAnalytics={onboardingProgressAnalytics}
            tableData={tableData}
          />
        );
      case 1:
        return <OnboardingUsers />;
      default:
        return null;
    }
  }

  render() {
    const {
      classes,
      onChangeTab,
      selectedTab,
      createAccountClicks,
      setupAccount,
      onboardingCompleted,
      completedAcctSetupPercentage,
      completedOnboardingPercentage,
    } = this.props;

    return (
      <React.Fragment>
        <Paper className={classes.paper} elevation={0}>
          <Grid container>
            <Grid item xs={12}>
              <Typography className={classes.subtitle} variant="subtitle1" gutterBottom>
                Onboarding
              </Typography>
            </Grid>
            <Grid item xs={3}>
              Date range
            </Grid>
            <Grid item xs={3}>
              <div className={classes.entriesStartedValue}>{createAccountClicks}</div>
              <div className={classes.entriesDataTitle}>Create Account Clicks</div>
            </Grid>
            <Grid item xs={3}>
              <div className={classes.filteredEntriesValue}>
                {setupAccount}
                <span className={classes.entriesDataSubValue}>
                  {completedAcctSetupPercentage} %
                </span>
              </div>
              <div className={classes.entriesDataTitle}>Setup Account</div>
            </Grid>
            <Grid item xs={3}>
              <div className={classes.entriesCompletedValue}>
                {onboardingCompleted}
                <span className={classes.entriesDataSubValue}>
                  {completedOnboardingPercentage} %
                </span>
              </div>
              <div className={classes.entriesDataTitle}>Onboarding Completed</div>
            </Grid>
          </Grid>
        </Paper>
        <Paper className={classes.paper} elevation={0}>
          <Grid container>
            <Grid item xs={3}>
              <Tabs
                indicatorColor="primary"
                textColor="primary"
                value={selectedTab}
                onChange={onChangeTab}
                variant="fullWidth"
                scrollButtons="on"
              >
                <Tab label="PROGRESS" />
                <Tab label="USERS" />
              </Tabs>
            </Grid>
            <Grid item xs={12}>
              {this.renderSwitch(selectedTab)}
            </Grid>
          </Grid>
        </Paper>
      </React.Fragment>
    );
  }
}

export default withStyles(styles)(OnboardingAnalyticsHome);
